import React from "react";
import styled from "styled-components";

const ErrorText = styled.div`
  font-size: 10px;
  margin-top: 4px !important;
  text-align: left;
  color: #f46a6a;
  position: ${props => props.absoluteError ? 'absolute' : 'none'};
`;

function TextError({ invalid = false, errorText = "", absoluteError = false }) {
  if (invalid) {
    return <ErrorText absoluteError={absoluteError}>{errorText}</ErrorText>;
  }
}
export default TextError;
